import { render, staticRenderFns } from "./ListItemCmp.vue?vue&type=template&id=05fc88df&"
import script from "./ListItemCmp.vue?vue&type=script&lang=ts&"
export * from "./ListItemCmp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports